"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.generateDestinationUserUrl = generateDestinationUserUrl;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _globals = _interopRequireWildcard(require("@insided/shared/utils/globals"));

var _toKebabCase = require("@insided/shared/utils/toKebabCase");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * Generates the appropriate user profile URL based on application context
 */
function generateUserUrl(user) {
  var p = (0, _globals.getSubfolderPrefix)();

  if ((0, _globals.default)('application') === 'control') {
    return "".concat(p, "/member/profile?userid=").concat(user.id);
  }

  return "".concat(p, "/members/").concat((user === null || user === void 0 ? void 0 : user.name).toLowerCase(), "-").concat(user.id);
}
/**
 * Generates destination-specific user profile URL with kebab-case formatting
 * Use this for destination-only components that need proper URL formatting
 */


function generateDestinationUserUrl(username, userId) {
  return "".concat((0, _globals.getSubfolderPrefix)(), "/members/").concat((0, _toKebabCase.textToKebab)(username), "-").concat(userId);
}
/**
 * Determines the final URL to use for the user avatar
 */


function getUserUrl(disableLink, user) {
  if (disableLink) return undefined;
  if (user.url) return user.url;
  return generateUserUrl(user);
}

var AvatarLink = function AvatarLink(_ref) {
  var user = _ref.user,
      disableLink = _ref.disableLink,
      openInNewTab = _ref.openInNewTab,
      children = _ref.children,
      className = _ref.className;
  var userUrl = getUserUrl(disableLink, user); // Guardian clause: If no URL (link disabled), render as span

  if (!userUrl) {
    return (0, _preact.h)("span", {
      className: className
    }, children);
  } // Default: Render as link


  return (0, _preact.h)("a", {
    className: className,
    href: (0, _absoluteUrlRuntime.resolveUrl)(userUrl),
    target: openInNewTab ? '_blank' : undefined,
    rel: "noreferrer"
  }, children);
};

var _default = AvatarLink;
exports.default = _default;